import { CompanySettingsController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * IR delivery settings.
 * @example
 * ```html
 * <salaxy-ir-delivery-settings></salaxy-ir-delivery-settings>
 * ```
 */

export class IrDeliverySettings extends ComponentBase {

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = {};

  /** Uses the CompanySettingsController */
  public controller = CompanySettingsController;

  /** Default template is the view  */
  public defaultTemplate = "salaxy-components/settings/IrDeliverySettings.html";

}
